import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import styled, { css } from 'styled-components';

export const ListItemBlockStyled = styled(ExtendedNextLink)`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 10px 6px;
        cursor: pointer;

        background-color: ${theme.color.grayVeryLight};
        border-radius: ${theme.radius.big};
        text-decoration: none;
        transition: ${theme.transition};

        @media ${theme.mediaQueries.queryLg} {
            flex-direction: row;
            padding: 10px 12px;
        }

        &:hover {
            background-color: ${theme.color.blueVeryLight};
            text-decoration: none;
        }
    `}
`;

export const ListItemImageStyled = styled.div`
    ${({ theme }) => css`
        flex: 0 0 auto;
        height: 48px;
        margin-bottom: 6px;
        position: relative;
        width: 64px;

        @media ${theme.mediaQueries.queryLg} {
            margin-bottom: 0;
        }

        img {
            mix-blend-mode: multiply;
            max-height: 100%;
        }
    `}
`;

export const ListItemNameWrapperStyled = styled.div`
    flex: 1;
    margin: 0;
    line-height: 18px;
    max-width: 100%;
`;

export const ListItemNameStyled = styled.span`
    ${({ theme }) => css`
        display: block;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        max-width: 100%;

        word-wrap: break-word;
        font-size: ${theme.fontSize.small};
        color: ${theme.color.primary};
        overflow: hidden;

        @media ${theme.mediaQueries.queryLg} {
            padding-left: 10px;
        }
    `}
`;

export const ListItemCountStyled = styled.span`
    ${({ theme }) => css`
        margin-left: 8px;

        white-space: nowrap;
        color: ${theme.color.grayLight};
        font-size: 11px;
    `}
`;
